import { useMemo } from 'react'
import type { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import { useIntl } from 'react-intl'
import useSuggestedPackageOptionFromApi from './useSuggestedPackageOptionFromApi'
import useSuggestedPackageOptionFromTotalSales from './useSuggestedPackageOptionFromTotalSales'

interface Params {
  room?: OfferPageRoom
}

interface SuggestedPackageResult {
  option: App.OfferPackageOptionView
  message: string
}

function useSuggestedPackageOption({ room }: Params = {}): SuggestedPackageResult | undefined {
  const intl = useIntl()

  const { result: apiResult, isLoading: isApiLoading } = useSuggestedPackageOptionFromApi({ room })
  const totalSalesResult = useSuggestedPackageOptionFromTotalSales({ room })
  const fallbackMessage = intl.formatMessage({
    id: 'GWBj6fqC_d4k1vB-uUV7',
    defaultMessage: 'Popular for our users',
  })

  return useMemo(() => {
    if (apiResult) {
      return apiResult
    }

    if (isApiLoading || !totalSalesResult) {
      return undefined
    }

    return {
      ...totalSalesResult,
      message: fallbackMessage,
    }
  }, [apiResult, isApiLoading, totalSalesResult, fallbackMessage])
}

export default useSuggestedPackageOption
